module.exports = __webpack_public_path__ + "static/media/se.60e9ef4c.svg";